import { render, staticRenderFns } from "./MaintainCost.vue?vue&type=template&id=10c6a6c8&scoped=true&"
import script from "./MaintainCost.vue?vue&type=script&lang=js&"
export * from "./MaintainCost.vue?vue&type=script&lang=js&"
import style0 from "./MaintainCost.vue?vue&type=style&index=0&id=10c6a6c8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c6a6c8",
  null
  
)

export default component.exports